import OrderActionType from '../actionTypes/OrderActionType';

const initialState = { choiceCustomer: [] };

export default (state = initialState, action) => {
  switch (action.type) {
    case OrderActionType.UPDATE_CUSTOMER:
      return { ...state, choiceCustomer: action.choiceCustomer };
    case OrderActionType.UPDATE_CURRENT_ORDER:
      return { ...state, currentOrder: action.currentOrder };
    case OrderActionType.UPDATE_ORDER:
      return { ...state, orderUpdated: action.orderUpdated };
    case OrderActionType.DELETE_ORDER:
      return { ...state, orderDeleted: action.orderDeleted };
    case OrderActionType.CREATE_ORDER:
      return { ...state, orderCreated: action.orderCreated };
    case OrderActionType.CREATE_NEW_CUSTOMER:
      return { ...state, customerCreated: action.customerCreated };
    case OrderActionType.CREATE_NEW_PRODUCT:
      return { ...state, productCreated: action.productCreated };
    case OrderActionType.SELECTED_PRODUCT:
      return { ...state, productSelected: action.productSelected };
    case OrderActionType.UPDATE_HOURLY:
      return { ...state, hourlyData: action.hourlyData };
    default:
      return state;
  }
};
